import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
	fetchCutoff,
	cutOffMissedUpdatePaymentDate,
	cutOffMissedUpdatePaymentChapsDate,
} from '../states/calendar/actions';
import {
	checkIfPastCutOff,
	checkIfPastChapsCutOff,
	getNextAvailableDate,
	getChapsNextAvailableDate,
	getFirstSubmissionDate,
} from '../states/calendar/selectors';
import { isAuthorisationEdit } from '../states/modes/selectors';
import { isRepeatingPayment } from '../states/payments/selectors';
import { getIsEditing } from '../states/chaps/selectors';

const mapState = (state) => ({
	isAuthorisationEdit: isAuthorisationEdit(state),
	isPastCutOff: checkIfPastCutOff(state),
	isPastChapsCutOff: checkIfPastChapsCutOff(state),
	nextAvailableDate: getNextAvailableDate(state),
	chapsNextAvailableDate: getChapsNextAvailableDate(state),
	isValidPaymentType: isRepeatingPayment(state),
	isChapsEditing: getIsEditing(state),
	firstSubmissionDate: getFirstSubmissionDate(state),
});

const mapDispatch = (dispatch) => ({
	fetchCutoff: () => dispatch(fetchCutoff()),
	cutOffMissedUpdatePaymentDate: (nextAvailableDate) => dispatch(cutOffMissedUpdatePaymentDate(nextAvailableDate)),
	cutOffMissedUpdateChapsPaymentDate: (chapsNextAvailableDate) =>
		dispatch(cutOffMissedUpdatePaymentChapsDate(chapsNextAvailableDate)),
});

export default (WrappedComponent) => {
	const withCalendar = class extends Component {
		componentDidMount() {
			const { isAuthorisationEdit, fetchCutoff, isValidPaymentType, isChapsEditing } = this.props;
			if ((isAuthorisationEdit && isValidPaymentType) || isChapsEditing) fetchCutoff();
		}

		componentDidUpdate(prevProps) {
			const {
				isAuthorisationEdit,
				isPastCutOff,
				isPastChapsCutOff,
				nextAvailableDate,
				chapsNextAvailableDate,
				cutOffMissedUpdatePaymentDate,
				cutOffMissedUpdateChapsPaymentDate,
				isChapsEditing,
			} = this.props;
			if (isAuthorisationEdit && prevProps.isPastCutOff !== isPastCutOff) {
				cutOffMissedUpdatePaymentDate(nextAvailableDate);
			}
			if (isChapsEditing && isPastChapsCutOff && prevProps.isPastChapsCutOff !== isPastChapsCutOff) {
				cutOffMissedUpdateChapsPaymentDate(chapsNextAvailableDate);
			}
		}

		render() {
			const { isAuthorisationEdit, nextAvailableDate } = this.props;

			if (isAuthorisationEdit) {
				return <WrappedComponent {...this.props} nextAvailableDate={nextAvailableDate} />;
			}

			return <WrappedComponent {...this.props} />;
		}
	};

	withCalendar.displayName = `withCalendar(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

	withCalendar.propTypes = {
		isAuthorisationEdit: PropTypes.bool,
		isPastCutOff: PropTypes.bool,
		isPastChapsCutOff: PropTypes.bool,
		handleRoute: PropTypes.func.isRequired,
		isValidPaymentType: PropTypes.bool,
		fetchCutoff: PropTypes.func.isRequired,
		nextAvailableDate: PropTypes.string,
		chapsNextAvailableDate: PropTypes.string,
		cutOffMissedUpdatePaymentDate: PropTypes.func.isRequired,
		cutOffMissedUpdateChapsPaymentDate: PropTypes.func.isRequired,
		isChapsEditing: PropTypes.bool,
	};

	return connect(mapState, mapDispatch)(withCalendar);
};
